import type { TenantStatus } from '../lib/types.ts';
import { Badge } from './ui/Badge.tsx';

const STATUS_LABELS: Record<TenantStatus, string> = {
  active: 'Activo',
  onboarding: 'Onboarding',
  suspended: 'Suspendido',
};

const STATUS_COLORS: Record<TenantStatus, 'success' | 'warning' | 'danger'> = {
  active: 'success',
  onboarding: 'warning',
  suspended: 'danger',
};

export function StatusBadge({ status }: { status: TenantStatus }) {
  return (
    <Badge color={STATUS_COLORS[status]} size="sm">
      {STATUS_LABELS[status]}
    </Badge>
  );
}
